export const REACTIVATE_SUBSCRIPTION_INIT = '@root/REACTIVATE_SUBSCRIPTION_INIT'
export const REACTIVATE_SUBSCRIPTION_SUCCESS =
  '@root/REACTIVATE_SUBSCRIPTION_SUCCESS'
export const REACTIVATE_SUBSCRIPTION_FAILURE =
  '@root/REACTIVATE_SUBSCRIPTION_FAILURE'

export const GET_SAMPLE_MENU_INIT = '@root/GET_SAMPLE_MENU_INIT'
export const GET_SAMPLE_MENU_SUCCESS = '@root/GET_SAMPLE_MENU_SUCCESS'
export const GET_SAMPLE_MENU_FAILURE = '@root/GET_SAMPLE_MENU_FAILURE'
